import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CompanyConfigurationService } from '../service/company-configuration.service';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss']
})
export class UserModalComponent {
  @Input() public companyId = '';
  @Output() public closeModal = new EventEmitter<void>();
  @Output() public saveModal = new EventEmitter<any>();

  public autocomplete = [];
  public fullList = [];
  public disableSave = true;
  public selectedValue: {
    id: string;
    name: string;
    nickname: string;
  };

  constructor(
    private companyService: CompanyConfigurationService
  ) { }

  setElement(event) {
    const currentValue = this.fullList.find(item => item.matched_record.name === event);
    this.selectedValue = {
      id: currentValue.matched_record.id,
      name: currentValue.matched_record.name,
      nickname: currentValue.matched_record.nickname
    };
    this.disableSave = false;
  }

  searchElement(event) {
    this.companyService.getAgentAutoComplete(event, this.companyId).subscribe(resp => {
      this.autocomplete = [];
      this.fullList = resp;
      resp.forEach(element => {
        this.autocomplete.push({
          type: 'Nome',
          description: element.matched_record.name,
        });
      });
    });
  }

  save() {
    this.saveModal.emit(this.selectedValue);
  }
}
